export const SHARE_ITEMS = [
    {id:'1', value:'facebook', img:'facebook-360.png', title: 'FaceBook'},
    {id:'2', value:'whatsapp', img:'whatsapp-360.png', title: 'WhatsApp'},
    {id:'3', value:'telegram', img:'telegram-360.png', title: 'Telegram'},
    {id:'4', value:'email', img:'email-360.png', title: 'E-mail'},
    {id:'5', value:'copy', img:'copy-360.png', title: 'Copiar o link do site'}
]